import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"padding":"20px"}
}
const _hoisted_2 = { class: "comment-layout" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "user-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isRightPosition ? '' : 'comment-scroll custom-scroll'),
    style: {"height":"100%","background-color":"#f9f9f9"}
  }, [
    _createElementVNode("ul", {
      class: _normalizeClass(_ctx.isRightPosition ? 'comment-scroll custom-scroll' : ''),
      style: _normalizeStyle([{"padding":"0 8px","width":"100%","list-style":"none","word-break":"break-word","margin-bottom":"0","display":"flex","flex-direction":"column-reverse"}, _ctx.ulStyle])
    }, [
      (_ctx.commentList.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(this.isRightPosition ? this.commentListReverse: this.commentList, (cmt, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["comment-item", _ctx.getLiClass(idx)]),
              key: cmt.commentId
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_router_link, {
                  to: '/' + cmt.user.userName,
                  style: {"padding-left":"0","padding-right":"0.5rem","display":"inline-block"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "comment-image",
                      style: {"border-radius":"50%"},
                      src: _ctx.urls.getUserImageSrc(cmt.user),
                      alt: "username"
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(cmt.user.userName), 1),
                  _createElementVNode("div", null, _toDisplayString(cmt.comment), 1)
                ])
              ])
            ], 2))
          }), 128))
    ], 6)
  ], 2))
}